import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { COLORS } from "components";

export const SendReminderModalHeader = ({
  onClose,
}: {
  onClose: () => void;
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: 3,
      py: 2,
      borderBottom: "1px solid",
      borderColor: "divider",
      flexShrink: 0,
    }}
  >
    <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "18px", color: COLORS.Romance }}>
      Send Missing Data Reminder
    </Typography>
        <IconButton onClick={onClose} size="small" sx={{ color: "text.secondary" }}>

      <CloseIcon fontSize="small" />
    </IconButton>
  </Box>
);
